import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import TabletDetails from './pages/categories/TabletDetails';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Events from './pages/Events';
import CommentCommander from './pages/CommentCommander';
import Tablettes from "./pages/categories/Tablettes";
import Mendiants from "./pages/categories/Mendiants";
import CafesGourmands from "./pages/categories/CafesGourmands";
import CreationsFlorales from "./pages/categories/CreationsFlorales";
import Evenements from "./pages/categories/Evenements";
import BoxDecouvertePage from "./pages/categories/BoxDecouverte";
import CoeurChocolat from "./pages/categories/CoeurChocolat";
import FraisesEnrobees from "./pages/categories/FraisesEnrobees";
import CarresOrient from "./pages/categories/CarresOrient";
import EcrinDouceur from "./pages/categories/EcrinDouceur";

// Scroll vers le haut à chaque changement de page
const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [location.pathname]);
  return null;
};

const ScrollHandler = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash === '#products') {
      setTimeout(() => {
        const section = document.getElementById('products');
        if (section) section.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';
  return isLoggedIn ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={
          <div className="min-h-screen flex flex-col">
            <Header />
            <ScrollToTop />
            <ScrollHandler />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/events" element={<Events />} />
                <Route path="/comment-commander" element={<CommentCommander />} />
                <Route path="/products" element={<Home />} />
                <Route path="/categories/tablettes" element={<Tablettes />} />
                <Route path="/categories/mendiants" element={<Mendiants />} />
                <Route path="/categories/cafes-gourmands" element={<CafesGourmands />} />
                <Route path="/categories/box-decouverte" element={<BoxDecouvertePage />} />
                <Route path="/categories/creations-florales" element={<CreationsFlorales />} />
                <Route path="/categories/coeurs-chocolat" element={<CoeurChocolat />} />
                <Route path="/categories/fraises-enrobees" element={<FraisesEnrobees />} />
                <Route path="/categories/evenements" element={<Evenements />} />
                <Route path="/categories/carres-orient" element={<CarresOrient />} />
                <Route path="/categories/ecrin-douceur" element={<EcrinDouceur />} />
                <Route path="/tablettes" element={<Tablettes />} />
                <Route path="/mendiants" element={<Mendiants />} />
                <Route path="/cafes-gourmands" element={<CafesGourmands />} />
                <Route path="/categories/tablettes/:id" element={<TabletDetails />} />
              </Routes>
            </main>
            <Footer />
          </div>
        } />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;